export const MALE = 'male';
export const FEMALE = 'female';
export const OTHER = 'other';
export const UNSPECIFIED = 'unspecified';
